import { Injectable } from '@angular/core';
import { INgsiEntityIdAttrs } from '../../shared/interfaces/ngsi/entity.interface';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { IDefaultObcNavInstruments } from '../../shared/oicl-navigations-components/oicl-navigations-instrument.constant';

@Injectable({
  providedIn: 'root'
})
export class InstrumentFieldService {
  private readonly selectedEntityId: Map<string, BehaviorSubject<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined>> =
    new Map<string, BehaviorSubject<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined>>();
  private readonly selectedInstrumentKey: Map<string, BehaviorSubject<keyof IDefaultObcNavInstruments | undefined>> =
    new Map<string, BehaviorSubject<keyof IDefaultObcNavInstruments | undefined>>();

  getInstrumentFieldEntity$(widgetId: string): Observable<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined> {
    if (!this.selectedEntityId.has(widgetId)) {
      this.selectedEntityId.set(widgetId, new BehaviorSubject<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined>(undefined));
    }

    return this.selectedEntityId.get(widgetId)!.asObservable();
  }


  setInstrumentFieldEntity(widgetId: string, entityId: Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined): void {
    if (!this.selectedEntityId.has(widgetId)) {
      this.selectedEntityId.set(widgetId, new BehaviorSubject<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined>(undefined));
    }

    this.selectedEntityId.get(widgetId)!.next(entityId);
  }


  // Clean up
  removeInstrumentFieldEntity(widgetId: string): void {
    const subject = this.selectedEntityId.get(widgetId);
    if (subject) {
      subject.complete(); // Clean up subscribers
      this.selectedEntityId.delete(widgetId);
    }
  }

  // Gets the observable for a specific widgetId
  getInstrumentFieldId$(widgetId: string): Observable<keyof IDefaultObcNavInstruments | undefined> {
    if (!this.selectedInstrumentKey.has(widgetId)) {
      this.selectedInstrumentKey.set(widgetId, new BehaviorSubject<keyof IDefaultObcNavInstruments | undefined>(undefined));
    }

    return this.selectedInstrumentKey.get(widgetId)!.asObservable();
  }

  // Sets a new Id for a specific widgetId
  setInstrumentFieldId(widgetId: string, instrumentKey: keyof IDefaultObcNavInstruments | undefined): void {
    if (!this.selectedInstrumentKey.has(widgetId)) {
      this.selectedInstrumentKey.set(widgetId, new BehaviorSubject<keyof IDefaultObcNavInstruments | undefined>(undefined));
    }


    this.selectedInstrumentKey.get(widgetId)!.next(instrumentKey);
  }

  // Clean up
  removeInstrumentFieldId(widgetId: string): void {
    const subject = this.selectedInstrumentKey.get(widgetId);
    if (subject) {
      subject.complete(); // Clean up subscribers
      this.selectedInstrumentKey.delete(widgetId);
    }
  }
}
